import "./Products2.module.css";
import Header from "@/reusable_sections/Header";
import ProductsHero from "./sections/ProductsHero";
import ProductsDescription from "./sections/ProductsDescription";
import ProductsGrid from "./sections/ProductsGrid";
import Footer from "@/reusable_sections/Footer";
export default function Products2Page() {
  return <div>
      <Header />
      <ProductsHero />
      <ProductsDescription />
      <ProductsGrid />
      <Footer />
    </div>;
}